export default {
    'FETCH_CHECKPOINTS' (state, data) {
        state.checkpoints = data;
  }
}